export default {
  siteName: "AllChinaBuy Spreadsheet",
  siteTagline: "Find Better Products, Compare Options & Shop Smarter",
  navHome: "Home",
  navCategories: "Categories",
  navGuides: "Guides",
  navShipping: "Shipping",
  navReviews: "Reviews",
  navSafety: "Safety",
  navComparisons: "Comparisons",
  navBlog: "Blog",
  navFaq: "FAQ",
  navAbout: "About",
  navContact: "Contact",
  navProducts: "Products",
  ctaMain: "Explore the Spreadsheet",
  ctaBuyNow: "Buy It Now",
  ctaGuide: "Read the Guide",
  ctaVisitMain: "Visit Main Website",
  trustIndependent: "Independent Resource",
  trustUpdated: "Updated Guides",
  trustLanguages: "4 Languages",
  heroTitle: "AllChinaBuy Spreadsheet — Find Better Products, Compare Options & Shop Smarter",
  heroSubtitle: "Explore AllChinaBuy spreadsheet resources, product finds, seller guides, QC tips, shipping information, reviews and practical buying advice — all in one place.",
  heroCtaPrimary: "Explore the AllChinaBuy Spreadsheet",
  heroCtaSecondary: "Start the Beginner Guide",
  sectionWhatIs: "What Is the AllChinaBuy Spreadsheet?",
  sectionWhatIsDesc: "The AllChinaBuy spreadsheet is a curated resource that helps shoppers discover quality products, compare sellers, and make informed purchasing decisions. It aggregates product finds, reviews, and buying tips into one organized hub.",
  sectionCategories: "Popular Spreadsheet Categories",
  sectionHowItWorks: "How the Spreadsheet Works",
  sectionHowItWorksStep1: "Browse categories or search for products",
  sectionHowItWorksStep2: "Compare sellers, prices, and QC details",
  sectionHowItWorksStep3: "Follow buying guides and safety tips",
  sectionHowItWorksStep4: "Purchase confidently through trusted links",
  sectionReview: "AllChinaBuy Review",
  sectionReviewDesc: "An independent, honest review of the AllChinaBuy platform covering shipping, QC, fees, warehouse services, and overall user experience. Updated regularly with real insights.",
  sectionShipping: "Shipping Cost Guide",
  sectionShippingDesc: "Understand how shipping costs are calculated based on weight, destination, parcel size, shipping line, and seasonal factors. Learn how to save on shipping with consolidation and insurance options.",
  sectionWarehouse: "Warehouse & QC",
  sectionWarehouseDesc: "Learn how the AllChinaBuy warehouse process works: from seller delivery to QC inspection, approval, consolidation, and final parcel shipping. Essential knowledge for every buyer.",
  sectionSafety: "Safety Center",
  sectionSafetyDesc: "Verify URLs, check seller ratings, inspect QC photos, and follow safe payment practices. Our safety guides help you avoid scams and shop with confidence.",
  sectionComparison: "AllChinaBuy vs Competitors",
  sectionComparisonDesc: "Compare AllChinaBuy with Superbuy, CSSBuy, and Sugargoo. See the differences in fees, shipping, QC, warehouse services, and user experience to find the best agent for your needs.",
  sectionArticles: "Latest Guides & Articles",
  sectionFaq: "Frequently Asked Questions",
  finalCtaTitle: "Ready to explore the AllChinaBuy spreadsheet?",
  finalCtaDesc: "Start with the latest spreadsheet resources, guides and buying information.",
  footerAbout: "About",
  footerPolicy: "Editorial Policy",
  footerDisclaimer: "Disclaimer",
  footerPrivacy: "Privacy Policy",
  footerTerms: "Terms",
  footerContact: "Contact",
  readMore: "Read More",
  learnMore: "Learn More",
  lastUpdated: "Last Updated",
  relatedArticles: "Related Articles",
  tableFeature: "Feature",
  tableAllChinaBuy: "AllChinaBuy",
  tableSuperbuy: "Superbuy",
  tableCSSBuy: "CSSBuy",
  tableSugargoo: "Sugargoo",
  categoryShoes: "Shoes",
  categorySneakers: "Sneakers",
  categoryHoodies: "Hoodies/Sweaters",
  categoryTShirts: "T-Shirts",
  categoryJackets: "Jackets",
  categoryPants: "Pants/Shorts",
  categoryHeadwear: "Headwear",
  categorySets: "Sets",
  categoryUnderwear: "Underwear/Underpants",
  categoryJersey: "Jersey",
  categoryAccessories: "Accessories",
  categoryBags: "Bags",
  categoryBelts: "Belts",
  categoryPerfumes: "Perfumes",
  categoryOther: "Other Stuff",
  articleTitle1: "AllChinaBuy Spreadsheet Guide 2026: How to Find the Best Products",
  articleDesc1: "A complete guide to navigating the AllChinaBuy spreadsheet, understanding categories, and finding quality products with verified sellers and QC tips.",
  articleTitle2: "Is AllChinaBuy Legit? Complete Safety & Trust Guide",
  articleDesc2: "An independent assessment of AllChinaBuy's legitimacy, safety practices, payment protection, and how to avoid common buying mistakes.",
  articleTitle3: "AllChinaBuy vs Superbuy: Which Agent Should You Choose?",
  articleDesc3: "A detailed comparison of AllChinaBuy and Superbuy covering fees, shipping, QC, warehouse services, and overall user experience.",
  faq1Q: "What is the AllChinaBuy spreadsheet?",
  faq1A: "The AllChinaBuy spreadsheet is a curated collection of product finds, seller information, and buying tips organized by category. It helps shoppers discover quality items and compare options before purchasing.",
  faq2Q: "Is AllChinaBuy safe to use?",
  faq2A: "AllChinaBuy is a legitimate shopping agent platform. However, like any international shopping service, buyers should follow safety practices: verify seller ratings, check QC photos, use secure payment methods, and read reviews before purchasing.",
  faq3Q: "How does shipping work with AllChinaBuy?",
  faq3A: "AllChinaBuy offers multiple shipping lines based on destination, weight, and parcel size. Costs depend on actual weight or volumetric weight, destination country, and chosen shipping method. Consolidation and insurance options are available.",
  faq4Q: "Can I trust the spreadsheet product recommendations?",
  faq4A: "The spreadsheet is an independent resource that compiles community finds and reviews. While we verify information to the best of our ability, always perform your own QC checks and read seller reviews before purchasing.",
  faq5Q: "What is QC and why is it important?",
  faq5A: "QC (Quality Control) is the inspection process where warehouse staff check your items for defects, sizing issues, or incorrect products before shipping. It is crucial for catching problems early and requesting exchanges or refunds.",
  pageNotFound: "Page Not Found",
  pageNotFoundDesc: "The page you are looking for does not exist. Return to the homepage to explore AllChinaBuy spreadsheet resources.",
  backToHome: "Back to Home",
  allchinabuySpreadsheet: "AllChinaBuy Spreadsheet",
  spreadsheetHub: "Spreadsheet Hub",
  comparison: "Comparison",
  warehouse: "Warehouse",
  review: "Review",
  coupon: "Coupon",
  discountCode: "Discount Code",
  legit: "Legit",
  shippingCost: "Shipping Cost",
  beginnersGuide: "Beginner's Guide",
  qcGuide: "QC Guide",
  sellerGuide: "Seller Guide",
  buyingChecklist: "Buying Checklist",
  productVerification: "Product Verification",
  safetyCenter: "Safety Center",
  paymentSafety: "Payment Safety",
  sellerSafety: "Seller Safety",
  qcSafety: "QC Safety",
  shippingSafety: "Shipping Safety",
  scamWarning: "Scam Warning",
  alternatives: "Alternatives",
  vsSuperbuy: "AllChinaBuy vs Superbuy",
  vsCSSBuy: "AllChinaBuy vs CSSBuy",
  vsSugargoo: "AllChinaBuy vs Sugargoo",
  languageEnglish: "English",
  languageFrench: "French",
  languageDanish: "Danish",
  languageGerman: "German",
  breadcrumbHome: "Home",
  editorialTitle: "Editorial Policy",
  editorialDesc: "This website provides independent educational information and is not affiliated with AllChinaBuy. We do not guarantee product quality, seller reliability, or shipping outcomes. Always verify information independently.",
  cookieNotice: "We use cookies to improve your experience. By continuing, you agree to our use of cookies.",
  cookieAccept: "Accept",
  productsTitle: "Product Catalog",
  productsSubtitle: "Browse our curated collection of verified products from the AllChinaBuy spreadsheet. Click any item to view details and purchase.",
  productsSearchPlaceholder: "Search products...",
  allCategories: "All",
  noProductsFound: "No products found.",
  buyNow: "Buy Now",
};